import { render } from "./UiMixin.vue?vue&type=template&id=4e5773f7"
import script from "./UiMixin.vue?vue&type=script&lang=js"
export * from "./UiMixin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__